import * as ationTypes from './action-types'
import * as mutationTypes from './mutation-types'

export default {    
  ...ationTypes,
  ...mutationTypes
}